export interface RouterState {
  history: string[];
  submittedRoute: string;
}

export const initialState: RouterState = {
  history: [window.location.pathname],
  submittedRoute: "",
};
